import { Blockquote } from "@mantine/core";
import React from "react";

export const EmptyBlock = <Blockquote cite="Что-то здесь пусто">Упс.</Blockquote>;
